import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { setAuthToken, resetTokenGate } from "components/AxiosUtils";
import { getUserToken, removeUserTokenFromLocalStorage, setUserTokenInLocalStorage } from "./UserUtils";
import { getAuth0Config } from "./UtilsForAuth0";

const auth0 = getAuth0Config();

export default function SetupAuthHeader() {
  const { isLoading, isAuthenticated, getAccessTokenSilently, loginWithRedirect } = useAuth0();

  useEffect(() => {
    let cancelled = false;

    // 🔥 Critical: do nothing until Auth0 has finished restoring session / handling callback
    if (auth0.isActive && isLoading) return;

    (async () => {
      if (!auth0.isActive) {
        const token = getUserToken();
        setAuthToken(token ?? null);
        return;
      }

      if (!isAuthenticated) {
        setAuthToken(null);
        resetTokenGate();
        return;
      }

      try {
        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience: auth0.audience,
            scope: "openid profile email read:current_user read:messages offline_access",
          },
        });

        if (!cancelled) {
          setUserTokenInLocalStorage(); // <-- make sure you store the token value
          setAuthToken(token);
        }
      } catch (e: any) {
        removeUserTokenFromLocalStorage();
        loginWithRedirect({
                authorizationParams: {
                  prompt: "login",
                },
              });
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [isLoading, isAuthenticated, getAccessTokenSilently, loginWithRedirect]);

  return null;
}
